// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// Update
import UpdateTournament from '@/graphql/tournaments/update/updateTournament.gql';
import CreateTournaments from '@/graphql/tournaments/create/createTournaments.gql';
import DeleteTournament from '@/graphql/tournaments/delete/deleteTournament.gql';
import GetTournaments from '@/graphql/tournaments/query/getTournaments.gql';

export default {
	state: {
		tournaments: [] as HasuraTournament[],
	},

	// ================ Getters ================
	getters: {
		tournaments(state: any) {
			return state.tournaments;
		},
	},

	// ================ Mutations ================
	mutations: {
		setTournaments(state: any, tournaments: any) {
			state.tournaments = tournaments;
		},
	},

	// ================= Actions =================
	actions: {
		async getTournaments({ commit }: any) {
			const response = await apolloClient.query({
				query: GetTournaments,
				fetchPolicy: 'no-cache',
			});

			const { tournaments } = response.data;
			commit('setTournaments', tournaments);
			return;
		},

		async getTournamentById({ commit }: any, { id }: any) {
			const response = await apolloClient.query({
				query: gql`
					query getTournament($id: uuid!) {
						tournaments(where: { id: { _eq: $id } }) {
							id
							frequency
							free_agents
							default_slot_duration
							default_pitches
							default_game_length
							day_of_week
							created_at
							corporate_event
							bbq_included
							kick_off_date
							location: locationByLocation {
								id
								name
								city {
									id
									name
								}
							}
							man_of_the_match
							name
							number_of_teams
							player_type
							status
							seedings {
								child_league
								child_tournament
								position
								placeholder
								parent
								id
							}
							matches {
								id
								away_score
								away_team
								awayTeamObj: team {
									id
									name
								}
								created_at
								date
								name
								game_length
								home_score
								home_team
								homeTeamObj: teamByHomeTeam {
									id
									name
								}
								is_friendly
								kick_off_time
								league
								location
								locationObj: locationByLocation {
									id
									name
									city {
										id
										name
									}
									pitches {
										id
										name
									}
								}
								man_of_the_match
								match_comments {
									id
									created_at
									author
									match
									text
								}
								pitch
								placeholder_away_team
								placeholder_home_team
								phHomeObj: placeholderTeamByPlaceholderHomeTeam {
									id
									name
									seeding_match
									type
								}
								phAwayObj: placeholder_team {
									id
									name
									seeding_match
									type
								}
								postponed
								published
								referee
								round
								slot_time
								tournament
								updated_at
								placeholder_teams {
									id
									name
									seeding_league
									seeding_match
									seeding_position
									seeding_group
									type
									updated_at
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					id,
				},
			});

			const { tournaments } = response.data;

			return tournaments[0];
		},

		async createTournament({ dispatch }: any, features: any) {
			const objects = [
				{
					id: features.id,
					default_game_length: features.default_game_length,
					default_slot_duration: features.default_slot_duration,
					number_of_teams: features.number_of_teams,
					name: features.name,
					default_pitches: features.default_pitches,
					location: features.location.id,
					kick_off_date: features.kick_off_date,
					frequency: features.frequency,
					man_of_the_match: features.man_of_the_match,
					bbq_included: features.bbq_included,
					free_agents: features.free_agents,
					player_type: features.player_type,
					day_of_week: features.day_of_week,
					corporate_event: features.corporate_event,
				},
			];

			await apolloClient
				.mutate({
					mutation: CreateTournaments,
					// Parameters
					variables: {
						objects,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getTournaments');
			return;
		},

		async deleteTournament({ dispatch }: any, id: string) {
			await apolloClient
				.mutate({
					mutation: DeleteTournament,
					// Parameters
					variables: {
						id,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getTournaments');
			return;
		},

		async updateTournament({ dispatch }: any, payload: any) {
			const { firstName, lastName, phoneNumber, email, city, id } = payload;
			await apolloClient.mutate({
				mutation: UpdateTournament,
				// Parameters
				variables: {
					refereeId: id,
					firstName,
					lastName,
					phoneNumber,
					email,
					city,
				},
			});

			dispatch('getTournaments');
			return;
		},
	},
};
